<template>
  <div>
    <template>
      <el-form
        style="margin-top: 26px;"
        :model="formAttributes"
        :rules="formRules"
        ref="form"
        label-width="0px"
        label-position="left"
        :disabled="disableForm"
        v-on:validate="onFormValidate"
      >
        <!-- shipping name -->
        <div class="el-form-element">
          <el-form-item
            prop="shipping_name"
            style="width: 100%"
            class="checkform-form-item"
          >
            <el-input
              name="shipping_name"
              ref="shipping_name"
              :placeholder="$t('scenes.checkout.address.form.name')"
              size="large"
              v-model="shipping_name"
            >
            </el-input>
          </el-form-item>
        </div>
        <!-- address line 1 & 2 -->
        <div class="el-form-element">
          <el-form-item class="checkform-form-item">
            <el-col :span="12">
              <el-form-item
                prop="shipping_address_1"
                class="checkform-form-item"
                :show-message="false"
              >
                <el-input
                  name="shipping-address-line1"
                  ref="input_shipping_address_line_1"
                  :placeholder="
                    $t('scenes.checkout.address.form.address_line_1')
                  "
                  size="large"
                  v-model="shipping_address_1"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 0.4em;">
              <el-form-item
                prop="shipping_address_2"
                class="checkform-form-item"
              >
                <el-input
                  name="shipping-address-line2"
                  :placeholder="
                    $t('scenes.checkout.address.form.address_line_2')
                  "
                  size="large"
                  v-model="shipping_address_2"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <!-- end address 1 & 2 -->
        </div>
        <!-- city -->
        <div class="el-form-element">
          <el-form-item
            prop="shipping_city"
            style="width: 100%"
            class="checkform-form-item"
            :show-message="false"
          >
            <el-input
              name="shipping_city"
              :placeholder="$t('scenes.checkout.address.form.address_city')"
              size="large"
              v-model="shipping_city"
            >
            </el-input>
          </el-form-item>
        </div>
        <!-- 3 line - country/state/postal; dynamic; based upon country -->
        <div class="el-form-element">
          <el-form-item class="checkform-form-item">
            <el-col :span="8">
              <el-form-item
                prop="shipping_country"
                class="checkform-form-item"
                style="padding-right: 0.4em;"
                :show-message="false"
              >
                <el-select
                  v-model="shipping_country"
                  placeholder="Select"
                  @change="onCountryChange"
                  disabled
                >
                  <el-option-group
                    v-for="group in countryGroupSelectOptions.options"
                    :key="group._key"
                    :label="group.label"
                  >
                    <el-option
                      v-for="item in group.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                prop="shipping_province"
                class="checkform-form-item"
                :show-message="false"
              >
                <el-select
                  auto-complete="1010101010"
                  v-model="shipping_province"
                  v-if="bShowStateProvinceDropDown"
                  :placeholder="strStateProvinceLabel"
                  filterable
                >
                  <el-option
                    v-for="item in arrStateProvinceSelectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="bShowStateProvinceDropDown ? 8 : 16">
              <el-form-item
                prop="shipping_postcode"
                class="checkform-form-item"
                style="padding-left: 0.4em;"
                :show-message="false"
              >
                <el-input
                  name="postal-code"
                  :placeholder="strPostalCodeLabel"
                  size="large"
                  v-model="shipping_postcode"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </div>
      </el-form>
      <slot name="footer"> </slot>
    </template>
  </div>
</template>

<script>
import {
  countrySelectOptions,
  generateGroupedSelectDropDown,
  usaStateSelectOptions,
  caProvinceSelectOptions
} from "@/util/ui.js";
import { mapFields } from "vuex-map-fields";
export default {
  name: "ShippingAddressForm",
  props: {
    // the props for the form use two way data binding via vuex
    disableForm: {
      type: Boolean,
      require: true
    },
    autoFocusForm: {
      type: Boolean,
      default: false
    },
    defaultShippingName: {
      type: String,
      required: false
    }
  },
  data() {
    const countryOptions = countrySelectOptions();
    const provinceStateValidator = (rule, value, callback) => {
      const isRequired =
        this.shipping_country === "CA" || this.shipping_country === "US";
      if (isRequired && !value) {
        callback(new Error());
      } else {
        callback();
      }
    };
    return {
      // Here we're going to generate the country dropdown options.
      // For a better UX, we show Canada/USA at the top,
      // in their own group.
      // Note: this dropdown is currently locked as we only support
      // domestic shipping
      countryGroupSelectOptions: generateGroupedSelectDropDown(
        countryOptions,
        "",
        "",
        ["CA", "US"]
      ),
      formRules: {
        shipping_name: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        shipping_address_1: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        shipping_city: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        shipping_province: [
          {
            validator: provinceStateValidator
          }
        ],
        shipping_postcode: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        shipping_country: [
          {
            required: true,
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    // this scenario is common for a new order, whereby the
    // name & email is auto populated
    if (!this.shipping_name && this.defaultShippingName) {
      this.shipping_name = this.defaultShippingName;
    }
    if (this.autoFocusForm) {
      if (this.shipping_name && !this.shipping_address_1) {
        this.$refs["input_shipping_address_line_1"].focus();
      } else if (!this.shipping_name) {
        this.$refs["shipping_name"].focus();
      }
    }
  },
  computed: {
    // todo, these could be moved to a mixin as the logic
    // is duplicated in the order address form
    strPostalCodeLabel() {
      return this.address_country === "US"
        ? "Zip"
        : this.address_country === "GB"
        ? "Postcode"
        : "Postal Code";
    },
    strStateProvinceLabel() {
      return this.shipping_country === "US"
        ? "State"
        : this.shipping_country === "CA"
        ? "Province"
        : "State";
    },
    arrStateProvinceSelectOptions() {
      switch (this.shipping_country) {
        case "US":
          return usaStateSelectOptions();
        case "CA":
          return caProvinceSelectOptions();
        default:
          return [];
      }
    },
    bShowStateProvinceDropDown() {
      return this.shipping_country === "CA" || this.shipping_country === "US";
    },
    // these fields will have their corresponding
    // getter and setter functions created for two-way data binding in Vuex
    // this allows the form state of this component to be easily accessible
    // by the parent, without having to explicitly define getters/setters
    // for every property in the form.
    ...mapFields([
      "forms.shippingForm.formIsValid",
      "forms.shippingForm.formAttributes",
      "forms.shippingForm.formAttributes.shipping_name",
      "forms.shippingForm.formAttributes.shipping_address_1",
      "forms.shippingForm.formAttributes.shipping_address_2",
      "forms.shippingForm.formAttributes.shipping_city",
      "forms.shippingForm.formAttributes.shipping_province",
      "forms.shippingForm.formAttributes.shipping_postcode",
      "forms.shippingForm.formAttributes.shipping_country"
    ])
  },
  methods: {
    onCountryChange() {
      // reset state/province dropdown when the country changes, since it is country specific
      // n/a for now as we only support domestic shipping (country is locked)
      this.shipping_province = null;
    },
    // whenever the validation event of the form is emitted,
    // we sync the result with vuex.
    // this pattern is reused in other child components, which allows
    // the parent to know whether there are any issues
    // preventing the layout being saved to API.
    onFormValidate(formItemName, bIsValid) {
      console.log(
        `[ShippingForm] onFormValidate - prop: ${formItemName} | isValid: ${bIsValid}`
      );
      this.formIsValid = bIsValid;
    }
  }
};
</script>

<style>
.checkform-form-item {
  margin-bottom: 5px;
}
/* this disables the green border effect for form elements which are valid */
.checkform-form-item.el-form-item.is-success .el-input__inner,
.checkform-form-item.el-form-item.is-success .el-input__inner:focus,
.checkform-form-item.el-form-item.is-success .el-textarea__inner,
.checkform-form-item.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #dcdfe6;
}
.address-step-footer {
  margin-top: 30px;
  padding-left: 10px;
  padding-right: 10px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -webkit-flex-direction: row-reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
</style>
